module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-6.a030b088.svg";